<div class="login-wrapper d-flex align-items-center justify-content-center vh-100 pb-5">
  <div class="login-card card shadow p-4 mb-5" style="width: 360px;">
    <div class="text-center d-flex align-items-center justify-content-center mb-2">
      <img src="assets/images/logo-rg-36-black.svg" alt="Renault Group" class="logo-img" />
      <span class="ms-2 fw-semibold">DSP Planner</span>
    </div>

    <form (ngSubmit)="onSubmit()">
      <div class="mb-3">
        <label class="form-label">Usuario</label>
        <input type="text" class="form-control" [ngModel]="user()" (ngModelChange)="user.set($event)" name="user" autocomplete="username" required />
      </div>

      <div class="mb-3">
        <label class="form-label">Contraseña</label>
        <input type="password" class="form-control" [ngModel]="password()" (ngModelChange)="password.set($event)" name="password" autocomplete="current-password" required />
      </div>

      @if (error()) {
      <div class="alert alert-danger py-2 small">{{ error() }}</div>
      }

      <div class="mt-4 d-flex justify-content-end">
        <button type="submit" class="btn-field-blue" [disabled]="loading()">
          @if (loading()) {
          <span class="spinner-border spinner-border-sm me-2"></span>
          }
          Entrar
        </button>
      </div>
    </form>
  </div>
</div>